import { useState } from "react";
import { useNavigate } from "react-router";

import Button from "../common/Button";
import Card from "../common/Card";
import Form from "../common/Form";
import Page from "../common/Page";

import APIManager from "../../managers/APIManager";

import { Translation } from "react-i18next";
import { capitalize } from "../../utils/manipulateText";
import { faCloudUploadAlt } from "@fortawesome/free-solid-svg-icons";

const UploadVideo = () => {
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({ source: "" });
  const navigate = useNavigate();

  const onChange = (e) => {
    e.preventDefault();
    const valuesVar = values;
    valuesVar[e.target.name] = e.target.value;
    setValues(valuesVar);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    APIManager.createVideo(values).then(() => {
      navigate("/videos");
    });
  };

  return (
    <Page title="Upload Video">
      <Card className="max-w-lg m-auto">
        <Card.Body>
          <Form onSubmit={onSubmit}>
            <Form.FormTextInput
              autoFocus={true}
              name="source"
              label="Video URL"
              placeholder="https://www.youtube.com/watch?v=1A2B3C4D"
              onChange={onChange}
              value={values && values.source}
            />
            <div className="flex justify-end mt-4">
              <Button
                color="primary"
                disabled={!values.source.length || loading}
                loading={loading}
                onClick={onSubmit}
                icon={faCloudUploadAlt}
              >
                <Translation>
                  {(t) => capitalize(t("upload video"))}
                </Translation>
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
      <div className="mx-auto w-full md:w-1/2 mt-6 p-4 bg-orange-100 border-l-4 border-orange-500 text-orange-700 text-center text-sm">
        <ul className="list-disc list-inside">
          <li>
            <strong>Supported platforms:</strong> youtube & dailymotion.
          </li>

          <li>
            After upload, your video will be queued for processing. It can take
            up to <strong>10 minutes</strong>. You can follow the status of your
            video on the <em>/videos</em> page.
          </li>
        </ul>
      </div>
    </Page>
  );
};

export default UploadVideo;
